import lg from '@/utils/lg';

export default {
  install(Vue) {
    Vue.prototype.$lg = lg;
  }
}